import React from "react";

interface IProps {
  className?: string;
  size?: number;
}

const ArrowIcon: React.FC<IProps> = ({ className = "", size = 16 }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M0 8.00072C0 7.8846 0.020709 7.77206 0.0621252 7.66312C0.10356 7.55417 0.17468 7.45208 0.275485 7.35684L7.22943 0.786782C7.39652 0.628919 7.58847 0.549988 7.80529 0.549988C8.02209 0.549988 8.21404 0.628919 8.38114 0.786782C8.54823 0.944662 8.63177 1.12341 8.63177 1.32303C8.63177 1.52264 8.54823 1.70138 8.38114 1.85926L2.68869 7.23747H15.2087C15.438 7.23747 15.6271 7.31053 15.7763 7.45665C15.9254 7.60278 16 7.78413 16 8.00072C16 8.2173 15.9227 8.39866 15.768 8.54478C15.6133 8.69091 15.4214 8.76397 15.1922 8.76397H2.68869L8.38114 14.1422C8.54823 14.3001 8.63177 14.4788 8.63177 14.6784C8.63177 14.878 8.54823 15.0568 8.38114 15.2147C8.21404 15.3725 8.02209 15.4514 7.80529 15.4514C7.58847 15.4514 7.39652 15.3725 7.22943 15.2147L0.275485 8.64459C0.17468 8.54935 0.10356 8.44889 0.0621252 8.3432C0.020709 8.23753 0 8.12337 0 8.00072Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { ArrowIcon };
